module.exports = __webpack_public_path__ + "images/registered-electrical-contractor-ireland-technology-stack-1200w.jpg";